module.exports = __webpack_public_path__ + "assets/drag.4a19e202.svg";